import {
  FacebookIcon,
  InstagramIcon,
  GoogleIcon,
  WhatsAppIcon,
  TwitterIcon,
  TikTokIcon,
} from "../../../components/Icons"
import type { SocialLink } from "../types"

interface SocialLinksProps {
  links: SocialLink[]
}

function getLinkIcon(linkName: string) {
  const name = linkName.toLowerCase()
  switch (name) {
    case "facebook":
      return <FacebookIcon className="h-4 w-4" />
    case "instagram":
      return <InstagramIcon className="h-4 w-4" />
    case "x":
      return <TwitterIcon className="h-4 w-4" />
    case "tiktok":
      return <TikTokIcon className="h-4 w-4" />
    case "whatsapp":
      return <WhatsAppIcon className="h-4 w-4" />
    case "google":
      return <GoogleIcon className="h-4 w-4" />
    default:
      return null
  }
}

export function SocialLinks({ links }: SocialLinksProps) {
  if (links.length === 0) return null

  return (
    <>
      {links.map((link) => (
        <span key={link.name}>
          <a href={link.url} target="_blank" rel="noopener noreferrer">
            {getLinkIcon(link.name)}
          </a>
        </span>
      ))}
    </>
  )
}
